import { render, staticRenderFns } from "./CrossSaleProducts.vue?vue&type=template&id=b6749b50"
import script from "./CrossSaleProducts.vue?vue&type=script&lang=js"
export * from "./CrossSaleProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports